import { render, staticRenderFns } from "./BeneAzienda.vue?vue&type=template&id=44eda3e4"
import script from "./BeneAzienda.vue?vue&type=script&lang=ts"
export * from "./BeneAzienda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports